module.exports = __webpack_public_path__ + "static/img/repayment.e1c319b8.png";